import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a record table for bonus report view.
 */
export default class recordTableBonusReportView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Datatable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            height: screen.width < 820 ? 405 : 0, // Conditional height based on screen width
            columns: [
                // Column definitions
                {
                    id: 'detailTittle', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Column height
                    tooltip: _('Detalles'), // Tooltip text
                    template: function (obj) {
                        // Template for detail icon
                        return "<span class='webix_icon wxi-close details'></span>";
                    },
                },
                { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // ID column
                { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' }, // Date column
                { id: 'Type', header: _('Tipo'), width: 150, sort: 'int' }, // Type column
                {
                    id: 'Amount', // Amount column
                    header: _('Monto'), // Column header
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number', // Export type
                    width: 100, // Column width
                    sort: 'int', // Sort type
                },
                {
                    id: 'Description', // Description column
                    header: _('Descripción'), // Column header
                    width: 150, // Column width
                    sort: 'int', // Sort type
                },
            ],
            onClick: {
                // Event handler for clicking detail icon
                details: function (euv, id) {
                    var item = this.getItem(id); // Get clicked item
                    this.$scope.app.callEvent('bonusTransDetail:select', [item]); // Trigger event with item
                    $$('a5').scrollTo(0, 1000); // Scroll to a specific position
                },
            },
            tooltip: true, // Enable tooltips
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the grid and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var url = devConfig.geturlApi() + 'es/Report/GetClientBonusReportDetail'; // API URL
        var filter = ''; // Filter string
        this.on(this.app, 'bonusReport:filter', (filterData) => {
            // Event listener for filter
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object values
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateTo=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateFrom=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });
        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID
            grid.load(url + '?id=' + idUser); // Load data for specific user
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('bonusTransDetail:select', [item]); // Trigger event with item
        });
    }
}

// FILE DOCUMENTED
